// TODO: consider to move this enum into component file once we migrate it on TypeScript or replace with some common enum
var InfoPresentation;
(function (InfoPresentation) {
  InfoPresentation["POPOVER"] = "POPOVER";
  InfoPresentation["MODAL"] = "MODAL";
})(InfoPresentation || (InfoPresentation = {}));

export { InfoPresentation };
//# sourceMappingURL=infoPresentations.mjs.map
